var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAuthBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-96"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.85,165.21a38.33,38.33,0,1,1-45-30.11A38.29,38.29,0,0,1,105.85,165.21Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9,167A29.21,29.21,0,1,1,62.6,144,29.18,29.18,0,0,1,96.9,167Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.71,166.08c-.17,0-.54-1.2-1.43-3.3a31.12,31.12,0,0,0-5-8.13,29.42,29.42,0,0,0-4.82-4.46,29.09,29.09,0,0,0-6.57-3.62A26.58,26.58,0,0,0,75,145.35a28.12,28.12,0,0,0-4.17-.67,27.81,27.81,0,0,0-4.38,0,31.25,31.25,0,0,0-4.45.66,30.43,30.43,0,0,0-4.31,1.35,29.77,29.77,0,0,0-3.92,1.94A28.11,28.11,0,0,0,50.28,151a26.07,26.07,0,0,0-3,2.78A29.29,29.29,0,0,0,43,159.94a30,30,0,0,0-2.38,6.12,30.8,30.8,0,0,0-1,9.51c.11,2.28.32,3.55.15,3.59s-.63-1.17-1-3.5a27.05,27.05,0,0,1,.31-10,29.11,29.11,0,0,1,2.27-6.58,29.61,29.61,0,0,1,4.45-6.67,28.16,28.16,0,0,1,3.12-3.05,27.85,27.85,0,0,1,3.7-2.66,29.76,29.76,0,0,1,4.22-2.13,29.84,29.84,0,0,1,9.45-2.17,30.88,30.88,0,0,1,4.72.07,29.64,29.64,0,0,1,4.49.78,28.59,28.59,0,0,1,4.13,1.38,29.09,29.09,0,0,1,11.85,9,27.13,27.13,0,0,1,4.63,8.83C96.76,164.74,96.84,166.05,96.71,166.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.85,189.08l1.05,5-4.44.94-1-4.84c-4.45.67-9,.19-11.82-1.21l1.3-5.94a18.25,18.25,0,0,0,9.29,1.33l-1.58-7.42c-5.18-.15-11-.63-12.39-7-1-4.71,1.56-9.48,8.42-11.76l-1-4.94,4.44-.94,1,4.84a20.53,20.53,0,0,1,9.6.8l-1.06,5.94a18.66,18.66,0,0,0-7.29-.87l1.6,7.55c5.18.11,11,.61,12.28,6.87C84.18,182,81.65,186.75,74.85,189.08Zm-8.61-18.7-1.34-6.31c-2.24,1-2.9,2.52-2.59,4S64.15,170.17,66.24,170.38Zm9.91,9.09c-.33-1.56-1.79-2.13-3.85-2.39l1.3,6.13C75.72,182.25,76.46,180.89,76.15,179.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.6,301.12a22.42,22.42,0,1,1-26.32-17.61A22.39,22.39,0,0,1,208.6,301.12Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.37,302.16a17.09,17.09,0,1,1-20.06-13.43A17.06,17.06,0,0,1,203.37,302.16Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.26,301.63a10.17,10.17,0,0,1-.84-1.93,18.21,18.21,0,0,0-2.94-4.75,17.89,17.89,0,0,0-2.82-2.61,17.08,17.08,0,0,0-3.85-2.12,16.09,16.09,0,0,0-2.26-.71,15.14,15.14,0,0,0-2.44-.39,15.61,15.61,0,0,0-2.56,0,18,18,0,0,0-2.61.38,18.94,18.94,0,0,0-2.52.79,16.85,16.85,0,0,0-2.29,1.14,16.37,16.37,0,0,0-3.75,3,16.68,16.68,0,0,0-2.54,3.58,17.73,17.73,0,0,0-1.4,3.58,18.37,18.37,0,0,0-.57,5.56,10.12,10.12,0,0,1,.09,2.1,4.89,4.89,0,0,1-.59-2,15.88,15.88,0,0,1,.17-5.84,17.83,17.83,0,0,1,1.33-3.85,17.49,17.49,0,0,1,2.61-3.9,17.06,17.06,0,0,1,1.82-1.78,17.37,17.37,0,0,1,2.17-1.56,17.69,17.69,0,0,1,2.46-1.24,19,19,0,0,1,2.71-.86,18.44,18.44,0,0,1,2.82-.41,16.91,16.91,0,0,1,2.76,0,17.87,17.87,0,0,1,5.05,1.26,17.78,17.78,0,0,1,4,2.38,17.33,17.33,0,0,1,2.87,2.88,15.76,15.76,0,0,1,2.71,5.17A4.86,4.86,0,0,1,203.26,301.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.47,315.08l.62,2.91-2.6.55-.6-2.83A12.61,12.61,0,0,1,181,315l.75-3.48a10.79,10.79,0,0,0,5.44.78l-.92-4.34c-3-.09-6.46-.37-7.25-4.09-.59-2.75.91-5.54,4.92-6.88l-.61-2.89,2.6-.55.6,2.83a12.06,12.06,0,0,1,5.61.47l-.62,3.47a11.11,11.11,0,0,0-4.26-.51l.93,4.42c3,.07,6.41.36,7.19,4C195.93,311,194.45,313.72,190.47,315.08Zm-5-10.94-.79-3.69c-1.31.61-1.69,1.48-1.51,2.34S184.22,304,185.44,304.14Zm5.8,5.32c-.2-.91-1.05-1.24-2.26-1.4l.77,3.59C191,311.09,191.41,310.29,191.24,309.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439,237.42l-1.16,4.84-4.32-1,1.14-4.71c-4.21-1.28-8-3.61-9.92-6l3.64-4.69a18,18,0,0,0,7.64,5.07l1.73-7.2c-4.51-2.32-9.47-5.2-8-11.37,1.1-4.57,5.37-7.7,12.37-6.84l1.15-4.78,4.32,1-1.13,4.71a19.9,19.9,0,0,1,8.12,4.74l-3.43,4.78a18.24,18.24,0,0,0-6.06-3.83l-1.77,7.33c4.52,2.28,9.4,5.14,7.93,11.22C450.17,235.14,446,238.23,439,237.42Zm.28-20.1,1.47-6.13c-2.41,0-3.62,1-4,2.43S437.51,216.26,439.27,217.32Zm4.91,12.18c.37-1.51-.69-2.63-2.39-3.72l-1.43,5.95C442.63,231.77,443.85,230.88,444.18,229.5Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453,123.39l.38,8.57-7.66.34-.37-8.34c-7.6-.13-15-2.18-19.33-5.29l3.8-9.53a31,31,0,0,0,15.09,4.79l-.56-12.79c-8.59-1.69-18.21-4.11-18.7-15.06-.36-8.11,5.23-15.34,17.27-17.25l-.38-8.5,7.66-.34.37,8.34c5.76.21,11.42,1.49,15.75,4l-3.41,9.59A31.41,31.41,0,0,0,451,78.44l.57,13c8.59,1.61,18,4,18.53,14.83C470.48,114.25,465,121.4,453,123.39Zm-9.15-33.51L443.38,79c-4,1.1-5.53,3.39-5.42,5.92S440.44,89,443.86,89.88Zm14,17.87c-.11-2.68-2.4-4-5.74-5l.46,10.57C456.36,112.27,458,110.2,457.84,107.75Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-96"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M482,453.36c0,.14-103.87.26-232,.26s-232-.12-232-.26,103.85-.26,232-.26S482,453.22,482,453.36Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-96"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84.94,
    y: 42.03,
    width: 330.17,
    height: 247.68,
    rx: 7.21,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.9,289.71a7.24,7.24,0,0,0,5.67-2.83,7.25,7.25,0,0,0,1.49-4.67c0-7.62,0-18.85-.05-33.31,0-28.93-.05-70.79-.09-122.51q0-19.4,0-40.6,0-10.59,0-21.59V50.28a10,10,0,0,0-.22-2.74,7,7,0,0,0-3.2-4.3,6.85,6.85,0,0,0-2.6-.91,26.45,26.45,0,0,0-2.83-.08H314.66l-222.48,0a7,7,0,0,0-6,3.32,6.81,6.81,0,0,0-1,3.36c0,1.21,0,2.45,0,3.67v43.7q0,28.83,0,56.77c0,37.22,0,73.12,0,107.32v12.74c0,2.11,0,4.22,0,6.31,0,1.05,0,2.1,0,3.14a7,7,0,0,0,.7,2.92,7,7,0,0,0,4.51,3.7,11.19,11.19,0,0,0,3,.23h15.33l47.13,0,84.6,0,122.51.08,33.31.05,8.66,0c1.95,0,2.95,0,2.95,0l-2.95,0-8.66,0-33.31,0-122.51.09-84.6,0H93.41a12,12,0,0,1-3.14-.25,7.46,7.46,0,0,1-5.56-7.06v-22.2c0-34.2,0-70.1,0-107.32V52.65c0-1.23,0-2.44,0-3.69a7.43,7.43,0,0,1,1.09-3.61,7.52,7.52,0,0,1,6.4-3.58l222.48,0,50,0H406a23.46,23.46,0,0,1,2.89.08,7.35,7.35,0,0,1,2.76,1,7.42,7.42,0,0,1,3.4,4.56,10.63,10.63,0,0,1,.23,2.85V64.2q0,11,0,21.59,0,21.18,0,40.6c0,51.72-.06,93.58-.08,122.51,0,14.46,0,25.69,0,33.31a7.28,7.28,0,0,1-4.38,6.93,7.66,7.66,0,0,1-2.14.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.77,
    y: 79.75,
    width: 144.77,
    height: 65.45,
    rx: 8.21,
    style: {
      fill: "#E53A47"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.89,109.73v2.6h-2.32V109.8A11.08,11.08,0,0,1,324.8,108l1.28-2.83a9.36,9.36,0,0,0,4.49,1.65v-3.88c-2.57-.62-5.44-1.48-5.44-4.79,0-2.46,1.78-4.57,5.44-5V90.54h2.32v2.53a10.54,10.54,0,0,1,4.71,1.41l-1.16,2.85a9.58,9.58,0,0,0-3.55-1.2v3.94c2.57.6,5.4,1.46,5.4,4.72C338.29,107.21,336.53,109.29,332.89,109.73Zm-2.32-10.24V96.2c-1.23.27-1.71,1-1.71,1.71S329.55,99.16,330.57,99.49Zm4,5.58c0-.81-.67-1.25-1.67-1.6v3.2C334.05,106.42,334.56,105.81,334.56,105.07Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M344,126.1v2h-1.8v-2a8.51,8.51,0,0,1-4.46-1.43l1-2.19a7.25,7.25,0,0,0,3.48,1.27v-3c-2-.49-4.21-1.15-4.21-3.72,0-1.9,1.38-3.53,4.21-3.86v-2H344v2a8,8,0,0,1,3.64,1.09l-.9,2.21a7.14,7.14,0,0,0-2.74-.93v3.05c2,.46,4.18,1.13,4.18,3.66C348.18,124.14,346.82,125.76,344,126.1Zm-1.8-7.93v-2.55c-.95.21-1.32.73-1.32,1.33S341.41,117.92,342.2,118.17Zm3.09,4.32c0-.63-.52-1-1.29-1.24v2.48C344.9,123.53,345.29,123.07,345.29,122.49Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M357.74,107.33a1.86,1.86,0,0,1,0,.41c0,.31,0,.7,0,1.18,0,1.08,0,2.56,0,4.41v15.49l0-.15a6.45,6.45,0,0,0,3,1.57,15.68,15.68,0,0,0,3.73.42,12.51,12.51,0,0,0,7.47-2.23l-.09.2v0c0-7.93,0-15.27,0-21.28l0,.08a3.23,3.23,0,0,0-1.15-1.11,7.83,7.83,0,0,0-1.49-.65,13.59,13.59,0,0,0-3-.51,18.72,18.72,0,0,0-4.92.27,8.09,8.09,0,0,0-2.9,1.17,6.25,6.25,0,0,0-.63.54c-.12.14-.18.22-.19.21a2.26,2.26,0,0,1,.74-.85,7.76,7.76,0,0,1,2.93-1.31,18.77,18.77,0,0,1,5-.38,13.48,13.48,0,0,1,3.08.49,4.83,4.83,0,0,1,2.91,2l0,0v0c0,6,0,13.35,0,21.28v.14l-.09.07a12.88,12.88,0,0,1-7.81,2.35,15.32,15.32,0,0,1-3.85-.46,6.88,6.88,0,0,1-3.3-1.75l-.05-.05v-.1c.08-6.32.15-11.68.2-15.53,0-1.84.07-3.32.1-4.4,0-.47,0-.85,0-1.15A2.38,2.38,0,0,1,357.74,107.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.2,107.37a6.16,6.16,0,0,1-1.9,1.25,12,12,0,0,1-5.37,1.08,12.89,12.89,0,0,1-5.4-.94,6.14,6.14,0,0,1-1.93-1.2c0-.08.79.37,2.07.86a14.56,14.56,0,0,0,5.26.76,13.27,13.27,0,0,0,5.22-.9C371.42,107.76,372.15,107.29,372.2,107.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.2,112.68a6.06,6.06,0,0,1-1.9,1.26,12,12,0,0,1-5.37,1.07,12.73,12.73,0,0,1-5.4-.94,5.74,5.74,0,0,1-1.93-1.2c0-.08.79.37,2.07.86a14.56,14.56,0,0,0,5.26.76,13.29,13.29,0,0,0,5.22-.89C371.42,113.07,372.15,112.61,372.2,112.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.2,118a6.16,6.16,0,0,1-1.9,1.25,12.08,12.08,0,0,1-5.37,1.08,12.89,12.89,0,0,1-5.4-.94,6.14,6.14,0,0,1-1.93-1.2c0-.08.79.37,2.07.86a14.78,14.78,0,0,0,5.26.76,13.27,13.27,0,0,0,5.22-.9C371.42,118.39,372.15,117.92,372.2,118Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.2,123.31a6,6,0,0,1-1.9,1.25,11.81,11.81,0,0,1-5.37,1.08,12.89,12.89,0,0,1-5.4-.94,5.93,5.93,0,0,1-1.93-1.2c0-.08.79.37,2.07.86a14.56,14.56,0,0,0,5.26.76,13.47,13.47,0,0,0,5.22-.89C371.42,123.7,372.15,123.24,372.2,123.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.26,96.44a2.69,2.69,0,0,1,0,.62q0,.68,0,1.8c0,1.61,0,3.88,0,6.71v23.25l-.06-.15a6.67,6.67,0,0,0,3.11,1.58,14.9,14.9,0,0,0,3.74.41,12.46,12.46,0,0,0,7.39-2.23l-.09.2v0c0-12.42.05-23.73.06-32.17l0,.07a3.09,3.09,0,0,0-1.19-1.13,6.93,6.93,0,0,0-1.51-.66,13.91,13.91,0,0,0-3-.5,18.11,18.11,0,0,0-4.92.3,7.82,7.82,0,0,0-2.86,1.18,3.91,3.91,0,0,0-.6.53c-.13.13-.18.21-.19.21s0-.1.14-.25a3.59,3.59,0,0,1,.59-.58,7.42,7.42,0,0,1,2.87-1.3,18.14,18.14,0,0,1,5-.4,13.61,13.61,0,0,1,3.1.48,4.89,4.89,0,0,1,3,2v.08c0,8.44,0,19.75.07,32.17v.14l-.09.07a12.94,12.94,0,0,1-7.73,2.36,16.12,16.12,0,0,1-3.87-.44,6.93,6.93,0,0,1-3.37-1.77l-.05-.06v-.1c.08-9.42.15-17.51.2-23.29,0-2.83.08-5.09.1-6.7,0-.74,0-1.33.05-1.78A3.28,3.28,0,0,1,372.26,96.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.72,107.37a6.16,6.16,0,0,1-1.9,1.25,11.92,11.92,0,0,1-5.37,1.08,12.89,12.89,0,0,1-5.4-.94,6.14,6.14,0,0,1-1.93-1.2c0-.08.79.37,2.07.86a14.56,14.56,0,0,0,5.26.76,13.27,13.27,0,0,0,5.22-.9C385.94,107.76,386.67,107.29,386.72,107.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.72,112.68a6.06,6.06,0,0,1-1.9,1.26,11.92,11.92,0,0,1-5.37,1.07,12.73,12.73,0,0,1-5.4-.94,5.74,5.74,0,0,1-1.93-1.2c0-.08.79.37,2.07.86a14.56,14.56,0,0,0,5.26.76,13.29,13.29,0,0,0,5.22-.89C385.94,113.07,386.67,112.61,386.72,112.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.72,101.92a6.06,6.06,0,0,1-1.9,1.26,11.92,11.92,0,0,1-5.37,1.07,12.73,12.73,0,0,1-5.4-.94,5.93,5.93,0,0,1-1.93-1.2c0-.08.79.37,2.07.86a14.56,14.56,0,0,0,5.26.76,13.29,13.29,0,0,0,5.22-.89C385.94,102.31,386.67,101.85,386.72,101.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.72,96.44a6.16,6.16,0,0,1-1.9,1.25,12.05,12.05,0,0,1-5.37,1.08,12.89,12.89,0,0,1-5.4-.94,6.14,6.14,0,0,1-1.93-1.2c0-.08.79.36,2.07.85a14.54,14.54,0,0,0,5.26.77,13.27,13.27,0,0,0,5.22-.9C385.94,96.83,386.67,96.36,386.72,96.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.72,118a6.16,6.16,0,0,1-1.9,1.25,12.05,12.05,0,0,1-5.37,1.08,12.89,12.89,0,0,1-5.4-.94,6.14,6.14,0,0,1-1.93-1.2c0-.08.79.37,2.07.86a14.78,14.78,0,0,0,5.26.76,13.27,13.27,0,0,0,5.22-.9C385.94,118.39,386.67,117.92,386.72,118Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.72,123.31a6,6,0,0,1-1.9,1.25,11.78,11.78,0,0,1-5.37,1.08,12.89,12.89,0,0,1-5.4-.94,5.93,5.93,0,0,1-1.93-1.2c0-.08.79.37,2.07.86a14.56,14.56,0,0,0,5.26.76,13.47,13.47,0,0,0,5.22-.89C385.94,123.7,386.67,123.24,386.72,123.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.84,
    y: 79.75,
    width: 144.77,
    height: 65.45,
    rx: 8.22,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.32,109.68v2.6H169v-2.53a11,11,0,0,1-5.77-1.85l1.27-2.83a9.33,9.33,0,0,0,4.5,1.64v-3.87c-2.57-.62-5.45-1.48-5.45-4.79,0-2.46,1.79-4.57,5.45-5V90.49h2.32V93a10.46,10.46,0,0,1,4.7,1.41l-1.16,2.85a9.3,9.3,0,0,0-3.54-1.2V100c2.57.6,5.4,1.46,5.4,4.72C176.72,107.16,175,109.24,171.32,109.68ZM169,99.44V96.15c-1.23.27-1.72.95-1.72,1.71S168,99.11,169,99.44Zm4,5.58c0-.81-.68-1.25-1.67-1.6v3.2C172.48,106.37,173,105.76,173,105Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.43,126.05v2h-1.8v-2a8.55,8.55,0,0,1-4.47-1.43l1-2.19a7.25,7.25,0,0,0,3.48,1.27v-3c-2-.48-4.22-1.14-4.22-3.71,0-1.9,1.39-3.53,4.22-3.86v-2h1.8v2a8,8,0,0,1,3.64,1.09l-.9,2.21a7.19,7.19,0,0,0-2.74-.93v3c2,.46,4.18,1.13,4.18,3.66C186.61,124.09,185.24,125.71,182.43,126.05Zm-1.8-7.93v-2.55c-.95.21-1.33.73-1.33,1.33S179.84,117.87,180.63,118.12Zm3.09,4.32c0-.63-.52-1-1.29-1.24v2.48C183.32,123.48,183.72,123,183.72,122.44Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.78,102.89h-1.67v-.43H119v.43h-1.67v4.31h-.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.91,105.42a1.82,1.82,0,1,1,1.82,1.81A1.76,1.76,0,0,1,118.91,105.42Zm3.14,0a1.33,1.33,0,1,0-1.32,1.38A1.3,1.3,0,0,0,122.05,105.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.4,107a1.16,1.16,0,0,1-.76.25.94.94,0,0,1-1-1V104H123v-.41h.64v-.78h.48v.78h1.09V104h-1.09v2.13a.57.57,0,0,0,.62.65.83.83,0,0,0,.53-.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129,105v2.21h-.46v-.56a1.34,1.34,0,0,1-1.23.59c-.8,0-1.3-.42-1.3-1s.35-1,1.38-1h1.13V105c0-.61-.35-.94-1-.94a1.81,1.81,0,0,0-1.19.42l-.21-.36a2.22,2.22,0,0,1,1.45-.48A1.26,1.26,0,0,1,129,105Zm-.48,1.14v-.59h-1.12c-.69,0-.91.28-.91.64s.33.67.9.67A1.15,1.15,0,0,0,128.48,106.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.27,102.17h.48v5h-.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.54,104.83a2.49,2.49,0,1,1,2.5,2.41A2.39,2.39,0,0,1,133.54,104.83Zm4.48,0a2,2,0,1,0-2,2A1.93,1.93,0,0,0,138,104.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.34,103.61v.46h-.11a1.15,1.15,0,0,0-1.2,1.31v1.82h-.48v-3.57H140v.7A1.33,1.33,0,0,1,141.34,103.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.42,102.17v5H145v-.71a1.54,1.54,0,0,1-1.37.74,1.81,1.81,0,0,1,0-3.62,1.54,1.54,0,0,1,1.35.7v-2.14Zm-.47,3.25a1.33,1.33,0,1,0-1.32,1.38A1.3,1.3,0,0,0,145,105.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.87,105.56h-3a1.31,1.31,0,0,0,1.4,1.24,1.41,1.41,0,0,0,1.09-.46l.27.31a1.88,1.88,0,0,1-3.24-1.23,1.73,1.73,0,1,1,3.46,0Zm-3-.35h2.52a1.26,1.26,0,0,0-2.52,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.65,103.61v.46h-.11a1.15,1.15,0,0,0-1.2,1.31v1.82h-.48v-3.57h.46v.7A1.33,1.33,0,0,1,152.65,103.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.58,113.22v14.71h-3.4V116h-3v-2.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.14,125.16v2.77H124v-2.2l5.68-5.36c1.3-1.25,1.53-2,1.53-2.72,0-1.15-.8-1.83-2.35-1.83a3.61,3.61,0,0,0-3,1.48l-2.48-1.6a6.84,6.84,0,0,1,5.84-2.74c3.28,0,5.47,1.69,5.47,4.36,0,1.43-.4,2.73-2.46,4.64l-3.38,3.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.51,120.58c0-4.86,2.69-7.62,6.31-7.62s6.3,2.76,6.3,7.62-2.67,7.61-6.3,7.61S136.51,125.43,136.51,120.58Zm9.19,0c0-3.35-1.18-4.74-2.88-4.74s-2.86,1.39-2.86,4.74,1.17,4.73,2.86,4.73S145.7,123.92,145.7,120.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.6,
    y: 100.21,
    width: 42.41,
    height: 27.23,
    rx: 3.17,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.41,
    y: 105.22,
    width: 6.91,
    height: 2.51,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.76,112.89a22.32,22.32,0,0,1-4.89.27,22.45,22.45,0,0,1-4.9-.27,23.66,23.66,0,0,1,4.9-.26A23.52,23.52,0,0,1,207.76,112.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.46,112.89a11.21,11.21,0,0,1-4.89,0,11.63,11.63,0,0,1,4.89,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.67,112.89a24.87,24.87,0,0,1-7.31,0,25.82,25.82,0,0,1,7.31,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.63,112.89a23.21,23.21,0,0,1-7.06,0,24.09,24.09,0,0,1,7.06,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.39,119a25.26,25.26,0,0,1-7.23,0,25.26,25.26,0,0,1,7.23,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.53,121.59a42.37,42.37,0,0,1-6.69.26,42.19,42.19,0,0,1-6.68-.26,43.67,43.67,0,0,1,6.68-.26A43.86,43.86,0,0,1,211.53,121.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.67,121.59a15.48,15.48,0,0,1-5.65,0,8,8,0,0,1,2.82-.26A8,8,0,0,1,232.67,121.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.72,105.19h-1.67v-.44h3.84v.44h-1.67v4.31h-.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.85,107.71a1.82,1.82,0,1,1,1.82,1.82A1.76,1.76,0,0,1,269.85,107.71Zm3.14,0a1.33,1.33,0,1,0-1.32,1.39A1.3,1.3,0,0,0,273,107.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.33,109.28a1.13,1.13,0,0,1-.75.25.94.94,0,0,1-1-1v-2.15h-.64v-.41h.64v-.78H275v.78h1.08v.41H275v2.13a.57.57,0,0,0,.62.65.74.74,0,0,0,.52-.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.9,107.29v2.21h-.46v-.56a1.34,1.34,0,0,1-1.23.59c-.81,0-1.3-.42-1.3-1s.35-1,1.37-1h1.14v-.21a.88.88,0,0,0-1-1,1.85,1.85,0,0,0-1.19.42l-.22-.35a2.25,2.25,0,0,1,1.45-.49A1.28,1.28,0,0,1,279.9,107.29Zm-.48,1.14v-.59H278.3c-.69,0-.92.27-.92.64s.33.67.9.67A1.15,1.15,0,0,0,279.42,108.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.2,104.47h.48v5h-.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.14,109.5,287.06,108l-.38,0H285.4v1.51h-.5v-4.75h1.78c1.2,0,1.93.61,1.93,1.63a1.47,1.47,0,0,1-1.08,1.49l1.16,1.63Zm0-3.12c0-.76-.5-1.19-1.45-1.19H285.4v2.37h1.26C287.61,107.56,288.11,107.12,288.11,106.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.8,107.86h-3a1.31,1.31,0,0,0,1.4,1.24,1.41,1.41,0,0,0,1.09-.46l.27.31a1.74,1.74,0,0,1-1.37.58,1.77,1.77,0,0,1-1.87-1.82,1.72,1.72,0,0,1,1.74-1.81,1.7,1.7,0,0,1,1.73,1.81S292.8,107.81,292.8,107.86Zm-3-.36h2.53a1.27,1.27,0,0,0-2.53,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.71,105.93l-1.58,3.57h-.5l-1.57-3.57h.5l1.33,3,1.35-3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.39,107.86h-3a1.32,1.32,0,0,0,1.4,1.24,1.39,1.39,0,0,0,1.09-.46l.28.31a1.89,1.89,0,0,1-3.25-1.24,1.72,1.72,0,0,1,1.74-1.81,1.7,1.7,0,0,1,1.73,1.81S300.39,107.81,300.39,107.86Zm-3-.36h2.53a1.27,1.27,0,0,0-2.53,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.66,107.43v2.07h-.48v-2c0-.76-.39-1.14-1.07-1.14a1.17,1.17,0,0,0-1.25,1.29v1.87h-.48v-3.57h.46v.66a1.52,1.52,0,0,1,1.36-.69A1.37,1.37,0,0,1,304.66,107.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.18,105.93v3.57h-.46v-.65a1.43,1.43,0,0,1-1.28.68,1.38,1.38,0,0,1-1.51-1.53v-2.07h.48v2a1,1,0,0,0,1.07,1.15,1.17,1.17,0,0,0,1.22-1.3v-1.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.63,107.86h-3a1.31,1.31,0,0,0,1.4,1.24,1.41,1.41,0,0,0,1.09-.46l.27.31a1.89,1.89,0,0,1-3.25-1.24,1.72,1.72,0,0,1,1.75-1.81,1.69,1.69,0,0,1,1.72,1.81Zm-3-.36h2.52a1.26,1.26,0,0,0-2.52,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.64,128.05v1.67h-1.49V128.1a7.09,7.09,0,0,1-3.71-1.19l.82-1.82a6.13,6.13,0,0,0,2.89,1.06v-2.49c-1.65-.41-3.5-1-3.5-3.09,0-1.58,1.15-2.94,3.5-3.21v-1.65h1.49v1.62a6.78,6.78,0,0,1,3,.91l-.74,1.84a6.23,6.23,0,0,0-2.29-.78v2.54c1.66.38,3.48.94,3.48,3C275.12,126.43,274,127.77,271.64,128.05Zm-1.49-6.59v-2.11c-.79.18-1.1.61-1.1,1.1S269.5,121.26,270.15,121.46Zm2.57,3.6c0-.52-.43-.81-1.08-1v2.06C272.39,125.92,272.72,125.53,272.72,125.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280,117.5v10.43h-2.42v-8.49h-2.08V117.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.69,124.65c0,1.85-1.36,3.46-4.34,3.46a7.28,7.28,0,0,1-4-1.11l1-1.85a5,5,0,0,0,3,.94c1.21,0,2-.51,2-1.36s-.54-1.36-2.43-1.36h-2.67l.53-5.87h6.37v1.94H284.7l-.17,2h.85C288.47,121.42,289.69,122.81,289.69,124.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.49,126.59a3.39,3.39,0,0,1-.41,1.49l-.85,2.15h-1.47l.66-2.37a1.29,1.29,0,0,1-.81-1.27,1.39,1.39,0,0,1,1.45-1.43A1.37,1.37,0,0,1,293.49,126.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.38,122.72c0-3.45,1.91-5.4,4.47-5.4s4.48,2,4.48,5.4-1.9,5.39-4.48,5.39S294.38,126.16,294.38,122.72Zm6.52,0c0-2.37-.84-3.36-2-3.36s-2,1-2,3.36.83,3.35,2,3.35S300.9,125.09,300.9,122.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.5,122.72c0-3.45,1.91-5.4,4.47-5.4s4.47,2,4.47,5.4-1.89,5.39-4.47,5.39S304.5,126.16,304.5,122.72Zm6.51,0c0-2.37-.83-3.36-2-3.36s-2,1-2,3.36.84,3.35,2,3.35S311,125.09,311,122.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.61,122.72c0-3.45,1.91-5.4,4.48-5.4s4.47,2,4.47,5.4-1.89,5.39-4.47,5.39S314.61,126.16,314.61,122.72Zm6.52,0c0-2.37-.83-3.36-2-3.36s-2,1-2,3.36.84,3.35,2,3.35S321.13,125.09,321.13,122.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.14,274.77l.53,0a10.08,10.08,0,0,0,1.54-.2,10,10,0,0,0,8-9.35c.06-.91,0-1.86,0-2.85q0-5.93,0-13.63c0-10.26,0-22.81,0-37.38q0-10.92,0-23.34,0-6.19,0-12.74,0-3.27,0-6.63c0-1.11,0-2.25-.05-3.35a10.11,10.11,0,0,0-.9-3.22,9.84,9.84,0,0,0-4.71-4.75,10.11,10.11,0,0,0-3.32-.94c-1.16-.09-2.37,0-3.56,0H340.65l-68.86,0-157.78,0a10.05,10.05,0,0,0-4.89,1.28,9.93,9.93,0,0,0-3.6,3.51,9.79,9.79,0,0,0-1.41,4.82c0,1.72,0,3.46,0,5.18q0,10.36,0,20.59V263.7a15.23,15.23,0,0,0,.11,2.35,9.72,9.72,0,0,0,1.71,4.28,9.8,9.8,0,0,0,7.86,4.18h27.77l128.87.06,86.88.08,23.62.05,6.14,0,2.09,0-2.09,0-6.14,0-23.62.05-86.88.08L141.54,275H113.76a10.32,10.32,0,0,1-4.64-1.2,10.53,10.53,0,0,1-3.62-3.18,10.17,10.17,0,0,1-1.79-4.5,14.07,14.07,0,0,1-.12-2.42v-2.4q0-4.82,0-9.67V171.16c0-1.73,0-3.45,0-5.2a10.27,10.27,0,0,1,1.48-5.06,10.42,10.42,0,0,1,8.94-5.05l157.78,0,68.86,0h45.92c1.2,0,2.38,0,3.59.06a10.42,10.42,0,0,1,8.34,5.91,10.58,10.58,0,0,1,.92,3.34c.09,1.16,0,2.27.05,3.39v6.63q0,6.54,0,12.74,0,12.41,0,23.34c0,14.57,0,27.12-.05,37.38q0,7.7,0,13.63c0,1,0,1.94,0,2.85a10.54,10.54,0,0,1-.48,2.58,10.39,10.39,0,0,1-2.32,3.88,10.29,10.29,0,0,1-5.31,2.94,11.38,11.38,0,0,1-1.56.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.17,
    y: 229.97,
    width: 9.6,
    height: 38.11,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.55,
    y: 241.5,
    width: 9.6,
    height: 26.58,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.39,
    y: 241.5,
    width: 9.6,
    height: 26.58,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.23,
    y: 264.54,
    width: 9.6,
    height: 3.54,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.5,
    y: 259.2,
    width: 9.6,
    height: 8.88,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.48,
    y: 265.13,
    width: 9.6,
    height: 2.95,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.06,
    y: 265.13,
    width: 9.6,
    height: 2.95,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.69,
    y: 246.85,
    width: 9.6,
    height: 21.23,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.84,
    y: 252.68,
    width: 9.6,
    height: 15.4,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.98,
    y: 241.5,
    width: 9.6,
    height: 26.58,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.12,
    y: 224.9,
    width: 9.6,
    height: 43.18,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.26,
    y: 212.12,
    width: 9.6,
    height: 55.96,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.41,
    y: 229.97,
    width: 9.6,
    height: 38.11,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.55,
    y: 195.76,
    width: 9.6,
    height: 72.32,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.69,
    y: 229.97,
    width: 9.6,
    height: 38.11,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.83,
    y: 241.5,
    width: 9.6,
    height: 26.58,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.98,
    y: 246.49,
    width: 9.6,
    height: 21.59,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.12,
    y: 252.68,
    width: 9.6,
    height: 15.4,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,268.08l.94,0,2.77,0,10.64,0H150a29.07,29.07,0,0,0,4-.21,20.75,20.75,0,0,0,8.5-3,16.36,16.36,0,0,0,3.78-3.31,21.37,21.37,0,0,0,2.62-4.68c1.5-3.4,2.86-7.09,4.25-11s2.78-8,4.27-12.25c.75-2.13,1.51-4.3,2.39-6.48a37.58,37.58,0,0,1,3.28-6.4A26.32,26.32,0,0,1,188,215a22,22,0,0,1,6.63-3.88,23.23,23.23,0,0,1,7.8-1.37,28.93,28.93,0,0,1,8.07,1,21.27,21.27,0,0,1,3.88,1.49,19.55,19.55,0,0,1,3.51,2.35,21.87,21.87,0,0,1,5.21,6.75,51.44,51.44,0,0,1,3,8.16c.88,2.78,1.76,5.59,2.74,8.39a70.48,70.48,0,0,0,7.65,16.32,22.38,22.38,0,0,0,6.38,6.48,12.27,12.27,0,0,0,4.24,1.68,12.52,12.52,0,0,0,2.29.23c.78,0,1.56,0,2.33-.12a15.61,15.61,0,0,0,6-1.69,13.85,13.85,0,0,0,4.55-4.2c1.21-1.71,2.22-3.55,3.25-5.36a60,60,0,0,0,2.76-5.57c3.28-7.57,5.32-15.46,8.38-22.74a85.89,85.89,0,0,1,4.83-10.62,37.65,37.65,0,0,1,6.88-9,23.43,23.43,0,0,1,4.37-3.4,23,23,0,0,1,5-2.22,30.86,30.86,0,0,1,10.43-1.27,33.27,33.27,0,0,1,9.87,1.93,25.6,25.6,0,0,1,8.2,4.93c4.69,4.14,8.09,9,12,12.84a31.54,31.54,0,0,0,13,7.61,54.08,54.08,0,0,0,12.47,2.38h0l17.57.06,4.53,0c1,0,1.54,0,1.54,0l-1.54,0-4.53,0-17.57.06h0a54.08,54.08,0,0,1-12.56-2.33A32,32,0,0,1,338,216.4c-3.92-3.87-7.34-8.71-12-12.79a25.37,25.37,0,0,0-8.09-4.84,32.44,32.44,0,0,0-9.74-1.88,30.37,30.37,0,0,0-10.27,1.26,22.5,22.5,0,0,0-9.15,5.52,37.75,37.75,0,0,0-6.79,8.88,85.9,85.9,0,0,0-4.78,10.57c-3.05,7.26-5.08,15.13-8.38,22.76a59.54,59.54,0,0,1-2.77,5.61,60.51,60.51,0,0,1-3.29,5.41,14.27,14.27,0,0,1-4.72,4.35,15.93,15.93,0,0,1-6.23,1.76c-.79.11-1.59.08-2.38.12a12.83,12.83,0,0,1-2.39-.24,12.7,12.7,0,0,1-4.41-1.75,22.7,22.7,0,0,1-6.54-6.63,71.26,71.26,0,0,1-7.71-16.44c-1-2.81-1.86-5.63-2.73-8.41a51.79,51.79,0,0,0-3-8.08,21.23,21.23,0,0,0-5.09-6.6,18.55,18.55,0,0,0-3.41-2.3,21,21,0,0,0-3.79-1.46,28.24,28.24,0,0,0-7.94-1,22.77,22.77,0,0,0-7.64,1.33,23.34,23.34,0,0,0-11.34,9.29c-2.66,4-4.13,8.55-5.65,12.78s-2.93,8.35-4.3,12.25-2.78,7.58-4.3,11a21.93,21.93,0,0,1-2.68,4.74,16.76,16.76,0,0,1-3.87,3.36,21.15,21.15,0,0,1-8.61,3,28.25,28.25,0,0,1-4,.18H146.3l-10.64-.05-2.77,0C132.27,268.1,132,268.08,132,268.08Z",
    style: {
      fill: "#E53A47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225,179.58H171a1.53,1.53,0,0,0-1.53,1.53v18.57a1.52,1.52,0,0,0,1.53,1.53h27.32a1.52,1.52,0,0,1,1.13.5c.86.95,2,2.18,2.84,3.08a1.54,1.54,0,0,0,2.26,0l2.78-3.07a1.52,1.52,0,0,1,1.13-.5H225a1.53,1.53,0,0,0,1.53-1.53V181.11A1.54,1.54,0,0,0,225,179.58Z",
    style: {
      fill: "#E53A47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.78,232.46h-45a.91.91,0,0,0-.91.91v11a.91.91,0,0,0,.91.91H137a.89.89,0,0,1,.67.3c.51.56,1.19,1.3,1.69,1.83a.91.91,0,0,0,1.34,0l1.66-1.82a.89.89,0,0,1,.67-.3h22.71a.91.91,0,0,0,.91-.91v-11A.91.91,0,0,0,165.78,232.46Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.23,209.83a2.1,2.1,0,1,1-2.1-2.1A2.1,2.1,0,0,1,205.23,209.83Z",
    style: {
      fill: "#E53A47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.13,212a2.13,2.13,0,1,1,2.13-2.13A2.14,2.14,0,0,1,203.13,212Zm0-4.21a2.08,2.08,0,1,0,2.08,2.08A2.08,2.08,0,0,0,203.13,207.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.52,193.87v1h-.91v-1a4.35,4.35,0,0,1-2.29-.74l.5-1.12a3.78,3.78,0,0,0,1.79.66v-1.54c-1-.25-2.16-.59-2.16-1.9,0-1,.7-1.81,2.16-2v-1h.91v1a4,4,0,0,1,1.87.56l-.46,1.13a3.64,3.64,0,0,0-1.41-.48V190c1,.24,2.14.58,2.14,1.87C185.66,192.87,185,193.7,183.52,193.87Zm-.91-4.06v-1.3c-.49.11-.68.37-.68.68S182.2,189.68,182.61,189.81Zm1.58,2.21c0-.32-.27-.49-.67-.63v1.27C184,192.56,184.19,192.32,184.19,192Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.67,187.37v6.43h-1.49v-5.24h-1.29v-1.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.65,191.78c0,1.14-.84,2.13-2.68,2.13a4.46,4.46,0,0,1-2.45-.69l.59-1.14a3.09,3.09,0,0,0,1.83.58c.74,0,1.2-.31,1.2-.84s-.33-.83-1.5-.83H190l.33-3.62h3.92v1.19h-2.68l-.1,1.22H192C193.89,189.78,194.65,190.64,194.65,191.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197,193a2.18,2.18,0,0,1-.25.92l-.53,1.32h-.9l.4-1.46a.8.8,0,0,1-.5-.78.86.86,0,0,1,.9-.88A.85.85,0,0,1,197,193Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.54,190.58c0-2.12,1.17-3.32,2.75-3.32s2.76,1.2,2.76,3.32-1.17,3.33-2.76,3.33S197.54,192.7,197.54,190.58Zm4,0c0-1.46-.51-2.06-1.26-2.06s-1.25.6-1.25,2.06.52,2.07,1.25,2.07S201.55,192,201.55,190.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.77,190.58c0-2.12,1.18-3.32,2.76-3.32s2.76,1.2,2.76,3.32-1.17,3.33-2.76,3.33S203.77,192.7,203.77,190.58Zm4,0c0-1.46-.52-2.06-1.26-2.06s-1.25.6-1.25,2.06.51,2.07,1.25,2.07S207.79,192,207.79,190.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210,190.58c0-2.12,1.17-3.32,2.75-3.32s2.76,1.2,2.76,3.32-1.17,3.33-2.76,3.33S210,192.7,210,190.58Zm4,0c0-1.46-.51-2.06-1.26-2.06s-1.25.6-1.25,2.06.52,2.07,1.25,2.07S214,192,214,190.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.68,41.53H409.32a6,6,0,0,1,6,6V60.16a0,0,0,0,1,0,0H84.71a0,0,0,0,1,0,0V47.5A6,6,0,0,1,90.68,41.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.69,
    cy: 51.1,
    r: 2.66,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104.98,
    cy: 51.1,
    r: 2.66,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 113.27,
    cy: 51.1,
    r: 2.66,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-96"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M440.86,453.36A19.35,19.35,0,0,0,460,437.76c3.18-16.14,7.27-38.72,7.4-64.08.08-15.55-3.4-35.24-8.21-50-7-21.6-22.06-40.63-43.9-46.86-28.37-8.1-38.64-5-58.76,5.56-21.88,11.47-27.8,33-50.58,42.58-22.11,9.29-48.78,6.12-68.94,19.12-17.73,11.44-26.38,33.41-27.08,54.5a117.13,117.13,0,0,0,3.23,33.33c2.75,11.51,13.14,21.38,25,21.48Z",
    style: {
      fill: "#E53A47"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M440.86,453.36A19.35,19.35,0,0,0,460,437.76c3.18-16.14,7.27-38.72,7.4-64.08.08-15.55-3.4-35.24-8.21-50-7-21.6-22.06-40.63-43.9-46.86-28.37-8.1-38.64-5-58.76,5.56-21.88,11.47-27.8,33-50.58,42.58-22.11,9.29-48.78,6.12-68.94,19.12-17.73,11.44-26.38,33.41-27.08,54.5a117.13,117.13,0,0,0,3.23,33.33c2.75,11.51,13.14,21.38,25,21.48Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M426.28,280.64a2.69,2.69,0,0,1,.21.4c.14.3.33.7.58,1.21.51,1.1,1.23,2.67,2.16,4.67l1.55,3.38c.56,1.25,1,2.64,1.63,4.12s1.18,3.07,1.83,4.74,1.25,3.49,1.86,5.39,1.24,3.91,1.9,6c.36,1,.63,2.12.91,3.22s.57,2.21.86,3.35l.89,3.48c.15.58.31,1.18.46,1.77s.25,1.22.37,1.83c.5,2.46,1,5,1.52,7.58A242.12,242.12,0,0,1,446.52,366a288.39,288.39,0,0,1-1.36,34.35c-.63,5.25-1.14,10.25-2,14.88-.37,2.32-.68,4.57-1.07,6.71s-.81,4.2-1.19,6.16c-.71,3.94-1.58,7.45-2.28,10.54-.36,1.55-.69,3-1,4.31l-1,3.6c-.58,2.13-1,3.8-1.34,5l-.37,1.29a1.93,1.93,0,0,1-.14.43,2.67,2.67,0,0,1,.09-.45c.07-.32.18-.75.31-1.3.29-1.17.7-2.85,1.23-5,.27-1.08.58-2.29.91-3.6s.61-2.77,1-4.32c.67-3.1,1.51-6.61,2.19-10.55q.56-2.94,1.16-6.15c.37-2.15.67-4.4,1-6.71.78-4.63,1.27-9.63,1.89-14.86a292.28,292.28,0,0,0,1.3-34.29,244.58,244.58,0,0,0-3.45-34.11q-.75-3.89-1.49-7.56l-.36-1.82-.45-1.78c-.3-1.17-.59-2.33-.88-3.47s-.57-2.25-.84-3.35-.54-2.18-.89-3.21l-1.87-6c-.58-1.9-1.13-3.72-1.81-5.39s-1.23-3.27-1.78-4.75-1.05-2.88-1.58-4.13L429,287c-.88-2-1.57-3.6-2.06-4.71l-.52-1.23A1.94,1.94,0,0,1,426.28,280.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.86,453.2l-18.92,29.63-37-23.36c2.45-3.39,26.06,1.6,26.06,1.6l11.35-19.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.47,466.69a1.79,1.79,0,0,1-.05,2.38,1.71,1.71,0,0,1-2.36,0,1.89,1.89,0,0,1,.06-2.53,1.78,1.78,0,0,1,2.45.3",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M220.94,482.83l1.79-3.06-36.12-21.25s-2.1-.32-2.65,1Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M209.54,460.5c-.11.19.74.84,1.26,2s.52,2.2.73,2.23.6-1.18-.05-2.55S209.6,460.31,209.54,460.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.65,459.66c-.15.15.43.95.56,2.1s-.2,2.07,0,2.17.94-.84.75-2.27S204.76,459.49,204.65,459.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.51,462.91c.14.14,1-.6,1.12-1.89s-.43-2.21-.6-2.1,0,1-.13,2S199.34,462.78,199.51,462.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.62,456.35c0,.21.95.49,1.93,1.2s1.57,1.54,1.76,1.44-.16-1.22-1.33-2S212.62,456.15,212.62,456.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.27,452.52c-.05.07.59.63,1.86,1.16a9.72,9.72,0,0,0,2.31.63,10.79,10.79,0,0,0,1.42.1,2.52,2.52,0,0,0,.83-.08.93.93,0,0,0,.69-.91,1.16,1.16,0,0,0-.53-.91,2.88,2.88,0,0,0-.75-.34,7.8,7.8,0,0,0-3.82-.29,3.69,3.69,0,0,0-2,.81c0,.12.82-.19,2.11-.29a8.8,8.8,0,0,1,2.24.11,8.06,8.06,0,0,1,1.27.35c.46.14.79.35.78.59s0,.12-.17.18a2.62,2.62,0,0,1-.61.06c-.46,0-.91,0-1.33-.06a12,12,0,0,1-2.23-.45A14.85,14.85,0,0,0,216.27,452.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.34,452.93c0,.06.81-.36,1.62-1.48a7.2,7.2,0,0,0,1-2.19,7.79,7.79,0,0,0,.24-1.42,1.82,1.82,0,0,0-.6-1.68,1,1,0,0,0-1.1,0,3.07,3.07,0,0,0-.61.56,5.06,5.06,0,0,0-1.21,3.66c.12,1.42.73,2.11.79,2.06a20.54,20.54,0,0,1-.27-2.07,5,5,0,0,1,.52-2.11,4.23,4.23,0,0,1,.71-1c.3-.36.65-.58.77-.45s.31.61.27,1a6.69,6.69,0,0,1-.18,1.29,7.64,7.64,0,0,1-.81,2.07C216.88,452.28,216.26,452.84,216.34,452.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.33,361,255,394.25l-41.47-13.89c1.57-3.88,25.69-4.65,25.69-4.65l6.38-21.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.64,378.21a1.79,1.79,0,0,1,.53,2.32,1.71,1.71,0,0,1-2.3.54,1.88,1.88,0,0,1-.55-2.46,1.78,1.78,0,0,1,2.46-.3",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255,394.25l1-3.4L215.87,378.8s-2.12.18-2.34,1.56Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M238.61,375.27c-.06.21.93.64,1.7,1.62s1,2,1.24,2,.3-1.29-.66-2.47S238.63,375.07,238.61,375.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.66,375.61c-.11.18.65.82,1.05,1.91s.3,2.06.5,2.12.72-1.05.2-2.39S233.73,375.42,233.66,375.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.45,380c.17.11.79-.81.64-2.09s-1-2-1.09-1.91.25.93.35,2S229.25,379.91,229.45,380Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.62,370.51c0,.21,1,.24,2.16.7s1.89,1.12,2.05,1-.45-1.15-1.77-1.68S240.57,370.31,240.62,370.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.25,365.92a4.19,4.19,0,0,0,2.08.68,9.35,9.35,0,0,0,2.4.06,10.46,10.46,0,0,0,1.4-.23,2.74,2.74,0,0,0,.8-.28.93.93,0,0,0,.45-1,1.23,1.23,0,0,0-.73-.76,3,3,0,0,0-.82-.15,8.62,8.62,0,0,0-1.44,0,7.8,7.8,0,0,0-2.33.62c-1.26.57-1.85,1.21-1.79,1.28s.75-.38,2-.79a9.22,9.22,0,0,1,2.2-.43,8.3,8.3,0,0,1,1.31,0c.48,0,.86.15.9.38s0,.12-.12.22a2.17,2.17,0,0,1-.58.2,11.22,11.22,0,0,1-1.31.26,12.07,12.07,0,0,1-2.26.1A14.43,14.43,0,0,0,243.25,365.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.42,366.3c.06.05.71-.54,1.22-1.83a7.2,7.2,0,0,0,.48-2.37,7.11,7.11,0,0,0-.11-1.43,1.83,1.83,0,0,0-1-1.5,1,1,0,0,0-1.06.29,3.25,3.25,0,0,0-.47.69,4.82,4.82,0,0,0-.47,1.4,4.94,4.94,0,0,0,.17,2.44c.45,1.35,1.21,1.87,1.25,1.81a18.24,18.24,0,0,1-.75-1.94,5.15,5.15,0,0,1,0-2.18,4.58,4.58,0,0,1,.44-1.18c.21-.42.5-.72.65-.62s.44.51.5.92a7.34,7.34,0,0,1,.13,1.3,8,8,0,0,1-.29,2.21C243.79,365.54,243.32,366.23,243.42,366.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335,351.48s-31.21-50.09-39.77-64c-9.92-16.07-30.26-14-35.14.48,1.09-3.26-3.8,11.1-20.27,64.73l27.75,7.94,17.85-15.16,7.08,20.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "330.9 295.67 319.54 334.53 277.51 339.04 277.51 346.5 339.27 347.35 347.68 296.75 330.9 295.67",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.91,348.86H283.54a31.57,31.57,0,0,0-23.63,10.63,21.15,21.15,0,0,0-4.32,7.87l-42,78.36,26.83,14.82L290.58,389l28,.34L381,350.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.94,373.68a8.84,8.84,0,0,1,1.48,1.95,32.17,32.17,0,0,1,2.69,5.27,33,33,0,0,1,1.68,5.66,9.36,9.36,0,0,1,.28,2.43c-.17,0-.73-3.66-2.45-7.9S283.8,373.77,283.94,373.68Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.67,302.94,248,348.86h73.66l-3-6-21.34-.64L280,303.52a6.73,6.73,0,0,0-6.14-4H226.76A2.34,2.34,0,0,0,224.67,302.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.36,323.26a3,3,0,1,1-3-3A3,3,0,0,1,262.36,323.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.67,270.19c-2.45-11.09-19-15.3-26.46-15.32-10.41,0-9.47-.66-19.7,1.18l-1.35,0c-31.1-1.26-34.68,41.46-34.68,41.46l14.18,1.15h0l-3.75,29.43-10.85,20.83,59.73-.09,3.34-48.63,25-.66S414.15,281.4,411.67,270.19Z",
    style: {
      fill: "#E53A47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.38,279.42c.16,0-.89,10.39-2.35,23.17s-2.76,23.11-2.92,23.1.89-10.39,2.35-23.17S345.22,279.4,345.38,279.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M391,279.42c-2.55,12.18-5.87,24.69-8.41,36.87-.55,2.59-1.13,5.27-2.71,7.38a17.26,17.26,0,0,1-3.63,3.35c-5,3.76-10.31,7.29-16.21,9.44a145.76,145.76,0,0,0,25.23-4.39,6.88,6.88,0,0,0,3.79-2,7,7,0,0,0,1.14-3.62c1.83-15.61,1.3-31.35.8-47.07"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M308.5,333.6,327,331.38l13.05,8.55L390,328l1.46-27.84,22.4-.56-.53,32.68a19,19,0,0,1-19.48,18.56l-73.08-2-3.11-6.22L302,342.1Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390,328a6.26,6.26,0,0,1-.94.29l-2.71.7-10,2.5-33.08,8-3.08.73-.12,0-.11-.07-13-8.57.17,0-18.52,2.14.12-.07-4.89,6.21-1.32,1.64a3.33,3.33,0,0,1-.49.54,4.4,4.4,0,0,1,.41-.6l1.24-1.7,4.76-6.31.05-.06h.07L327,331.11h.1l.08,0,13.06,8.54-.23,0,3.08-.74,33.13-7.85,10.05-2.32,2.74-.6A6.09,6.09,0,0,1,390,328Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.25,338.91a44.85,44.85,0,0,1-7.19.29h-1.32l.19-.07a35.2,35.2,0,0,1-4.66,3.59,33.29,33.29,0,0,1,4.29-4l.08-.07h1.42A44.85,44.85,0,0,1,319.25,338.91Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.69,332.63a13.38,13.38,0,0,0-3.64-3.8c-2.48-1.6-5-1.45-5-1.63a3,3,0,0,1,1.61-.13,8.58,8.58,0,0,1,6.44,4.05A3.08,3.08,0,0,1,398.69,332.63Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.14,299.73h0l-5.45.2c-4.6.14-11,.3-18,.44l-2.25.05h-.29v-.28c-.25-6.52-.14-12.33,0-16.5.06-2.09.14-3.76.21-4.92a10.38,10.38,0,0,1,.17-1.79,11.51,11.51,0,0,1,.05,1.8c0,1.25,0,2.9,0,4.92,0,4.17-.07,10,.2,16.46l-.3-.27,2.26,0c7-.14,13.4-.23,18-.27l5.46,0C418.43,299.51,415.14,299.65,417.14,299.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.66,299.9a9.94,9.94,0,0,1-.72,1.44c-.24.46-.54,1-.94,1.63s-.81,1.35-1.35,2.1a52.66,52.66,0,0,1-4,5.12,58.31,58.31,0,0,1-5.71,5.55,59.32,59.32,0,0,1-6.47,4.64,51.93,51.93,0,0,1-5.75,3c-.84.4-1.63.69-2.31,1s-1.28.49-1.77.64a7.94,7.94,0,0,1-1.54.45,10,10,0,0,1,1.47-.64c.48-.18,1.07-.41,1.73-.71s1.44-.61,2.26-1a58.14,58.14,0,0,0,5.65-3.1,56.31,56.31,0,0,0,12.08-10.1,59.48,59.48,0,0,0,4.06-5c.55-.74,1-1.44,1.41-2.05s.74-1.13,1-1.57A9.88,9.88,0,0,1,378.66,299.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.58,268.13a3.75,3.75,0,0,1-.73,0l-2.09-.07-7.67-.3c-6.48-.22-15.43-.39-25.31-.26s-18.83.57-25.3,1l-7.66.5-2.08.13a4,4,0,0,1-.73,0,3,3,0,0,1,.72-.11l2.07-.23c1.81-.19,4.42-.42,7.65-.67,6.47-.5,15.42-1,25.32-1.12s18.86.1,25.34.42c3.23.15,5.85.31,7.66.45l2.08.17A3.9,3.9,0,0,1,410.58,268.13Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.12,288.47a82.89,82.89,0,0,1-13.12,0,82.89,82.89,0,0,1,13.12,0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.9,290.73a1.54,1.54,0,0,1-.46.1l-1.35.2c-1.17.16-2.86.36-5,.58-4.2.43-10,.9-16.46,1.15s-12.27.24-16.49.13c-2.11-.05-3.82-.12-5-.19l-1.35-.09a1.62,1.62,0,0,1-.47-.07,1.57,1.57,0,0,1,.47,0h1.36l5,0c4.22,0,10.05,0,16.47-.28s12.24-.66,16.44-1l5-.41,1.36-.1A1.4,1.4,0,0,1,390.9,290.73Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415,286.64c0,.14-5.32.74-11.91,1.33s-11.94.94-12,.8,5.32-.74,11.91-1.32S414.94,286.5,415,286.64Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.09,317.08a16.84,16.84,0,0,1-3.14.25c-1.95.08-4.64.12-7.62.05s-5.66-.24-7.6-.41a17.67,17.67,0,0,1-3.13-.4,19.86,19.86,0,0,1,3.15,0c1.95.08,4.63.18,7.6.25s5.65.1,7.59.12A20.35,20.35,0,0,1,363.09,317.08Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.56,317.94a5,5,0,0,1-1.13.24c-.73.13-1.79.28-3.11.45-2.63.32-6.29.66-10.34.82s-7.72.1-10.37,0c-1.33-.06-2.4-.13-3.14-.2a4.55,4.55,0,0,1-1.14-.16,5.18,5.18,0,0,1,1.15,0l3.14,0c2.65,0,6.31,0,10.34-.13s7.68-.44,10.32-.67l3.13-.28A4.57,4.57,0,0,1,390.56,317.94Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.22,337.08a14.18,14.18,0,0,1-5.11-1.28,14.42,14.42,0,0,1-4.58-2.64c.09-.13,2.1,1.09,4.77,2.16S347.25,336.93,347.22,337.08Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.16,200.78h-1A18.15,18.15,0,0,0,353,217.24c-.7,8.63-1.35,18.17-1.28,22.8.14,9.59,10,11.06,10,11.06l-.37,8.51a11.74,11.74,0,0,0,11,12.11h0a11.72,11.72,0,0,0,12.39-11.15l2-40.49C387.63,210.12,382.4,201.34,372.16,200.78Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.59,251.08a24.35,24.35,0,0,0,12.89-3.7s-3,6.91-12.85,6.06Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.45,223.19a1.39,1.39,0,0,0,1.36,1.38,1.34,1.34,0,0,0,1.45-1.24A1.4,1.4,0,0,0,357.9,222,1.34,1.34,0,0,0,356.45,223.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.09,221.92c.17.18,1.23-.59,2.75-.59s2.62.74,2.78.56-.09-.4-.58-.75a4,4,0,0,0-4.42,0C355.16,221.52,355,221.84,355.09,221.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.57,223.64a1.4,1.4,0,0,0,1.36,1.38,1.34,1.34,0,0,0,1.45-1.24A1.4,1.4,0,0,0,372,222.4,1.34,1.34,0,0,0,370.57,223.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.21,222.17c.17.18,1.24-.59,2.75-.59s2.62.73,2.79.55-.1-.4-.59-.74a3.86,3.86,0,0,0-2.23-.66,3.72,3.72,0,0,0-2.19.69C369.28,221.77,369.12,222.09,369.21,222.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.49,233.1a10.22,10.22,0,0,0-2.46-.42c-.38,0-.75-.11-.82-.37a1.88,1.88,0,0,1,.26-1.12l1.14-2.86c1.57-4.08,2.71-7.44,2.55-7.5s-1.59,3.2-3.17,7.28c-.38,1-.74,2-1.09,2.88a2.16,2.16,0,0,0-.19,1.48,1,1,0,0,0,.63.55,2.87,2.87,0,0,0,.66.09A9.88,9.88,0,0,0,364.49,233.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.94,234.11c-.24,0-.24,1.59-1.65,2.73s-3.15,1-3.16,1.19.39.31,1.13.32a4.1,4.1,0,0,0,2.64-.9,3.46,3.46,0,0,0,1.28-2.28C369.24,234.5,369.06,234.1,368.94,234.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.55,216.4c.15.4,1.66.21,3.44.41s3.21.67,3.44.31c.11-.17-.14-.54-.72-.93a6.1,6.1,0,0,0-5.24-.55C369.82,215.89,369.49,216.21,369.55,216.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.63,217.66c.27.33,1.31,0,2.56,0s2.32.22,2.56-.13c.11-.17-.06-.51-.52-.82a3.78,3.78,0,0,0-4.13.13C355.66,217.15,355.52,217.5,355.63,217.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.3,227.18c.17-.07,6.76-2,6.56,4.59s-6.92,5-6.92,4.82S385.3,227.18,385.3,227.18Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.48,234.16s.11.09.31.18a1.19,1.19,0,0,0,.87,0,2.8,2.8,0,0,0,1.42-2.49,3.55,3.55,0,0,0-.28-1.65,1.32,1.32,0,0,0-.85-.9.61.61,0,0,0-.7.29c-.1.18-.06.32-.1.33s-.14-.12-.07-.39a.7.7,0,0,1,.27-.4A1,1,0,0,1,388,229a1.64,1.64,0,0,1,1.19,1,3.81,3.81,0,0,1,.35,1.84,3,3,0,0,1-1.8,2.78,1.26,1.26,0,0,1-1.06-.2C386.48,234.32,386.45,234.17,386.48,234.16Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.89,207.7l-28.07.6a12.7,12.7,0,0,1,4.13-4.65,22.34,22.34,0,0,1,12.71-4.45c4.57-.08,13.89,5.35,17.2,8.42,2.66,2.46,2.64,4.59,2.64,4.59.42,3.55-1.61,7.57-2.42,11-.42,1.8-1.23,7.22-1.23,7.22h0c-1.55,0-2.12-1.2-1.88-2.69l.28-5.84a8.71,8.71,0,0,1-2.76-10.3C381.89,211.12,382.74,208.69,380.89,207.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375,228.42a.16.16,0,0,0,.19-.14.17.17,0,0,0-.12-.21.18.18,0,0,0-.2.15A.17.17,0,0,0,375,228.42Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.1,227.79a.19.19,0,0,0,.21-.17.19.19,0,0,0-.12-.23.19.19,0,0,0-.21.17A.19.19,0,0,0,372.1,227.79Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.16,227.75c.09,0,.18-.1.2-.25s0-.27-.14-.28-.18.1-.19.24S370.07,227.74,370.16,227.75Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.58,230.19c.09,0,.17-.05.16-.1s-.07-.11-.16-.11-.17.05-.17.11S373.49,230.19,373.58,230.19Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.93,229.6a.18.18,0,0,0,.18-.17.18.18,0,0,0-.15-.2.18.18,0,0,0-.18.17A.17.17,0,0,0,370.93,229.6Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.13,228a.18.18,0,1,0-.13-.21A.18.18,0,0,0,357.13,228Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.16,227.85c.09,0,.17-.08.19-.19a.17.17,0,1,0-.19.19Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.87,228.07a.17.17,0,0,0,.19-.11.14.14,0,0,0-.13-.17.17.17,0,0,0-.2.1A.17.17,0,0,0,358.87,228.07Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.41,230a.19.19,0,0,0,.23-.11.17.17,0,0,0-.07-.24.18.18,0,0,0-.23.11A.18.18,0,0,0,357.41,230Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.73,229.66a.14.14,0,0,0,.12-.17.16.16,0,0,0-.2-.09.15.15,0,0,0-.12.17A.15.15,0,0,0,355.73,229.66Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.05,208a7.82,7.82,0,0,0-1.58-7,8.31,8.31,0,0,0-6.71-3,25.84,25.84,0,0,1-3.92.28c-2.43-.26-4.3-2.15-6.55-3.07a8.67,8.67,0,0,0-10.09,2.94c-.86,1.24-1.42,2.78-2.72,3.56-1.13.68-2.56.62-3.83,1a6.1,6.1,0,0,0-4.2,6,7.2,7.2,0,0,0,4.49,6,9.17,9.17,0,0,0,7.75-.53c2.12-1.15,4-3.1,6.44-3s4.7,2.38,7.16,1.9a7,7,0,0,0,3.23-2.11,5.62,5.62,0,0,1,3.34-1.87c1.32-.08,2,1.68,1.53,2.88l5.66-3.92",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.37,204.83l0,.1c0,.06.09.15.17.26a4.17,4.17,0,0,0,.8.89,5,5,0,0,0,6.9-.4,33.59,33.59,0,0,0,1.94-2.88,4,4,0,0,1,1.36-1.2,4.15,4.15,0,0,1,1.86-.4,4.32,4.32,0,0,1,1.91.51,3.48,3.48,0,0,1,1.41,1.41,20.47,20.47,0,0,0,1,1.84,2.31,2.31,0,0,0,1.79,1.06,3.53,3.53,0,0,0,2-.55,6.82,6.82,0,0,0,1.49-1.2,6.29,6.29,0,0,1,2.78-1.93,3.62,3.62,0,0,1,2.82.65,4.69,4.69,0,0,1,1.55,1.86,7.63,7.63,0,0,1,.58,1.76c.1.5.15.9.19,1.16a1.51,1.51,0,0,0,.06.41v-.11c0-.06,0-.17,0-.3a11.15,11.15,0,0,0-.14-1.18,7.37,7.37,0,0,0-.54-1.8,5,5,0,0,0-1.57-1.95,3.8,3.8,0,0,0-3-.71,6.34,6.34,0,0,0-2.9,2,7.11,7.11,0,0,1-1.45,1.16,3.39,3.39,0,0,1-1.81.51,2.06,2.06,0,0,1-1.59-1c-.38-.54-.63-1.2-1-1.82a3.78,3.78,0,0,0-1.51-1.51,4.46,4.46,0,0,0-2-.53,4.31,4.31,0,0,0-2,.43,4.16,4.16,0,0,0-1.44,1.28c-.74,1-1.18,2.09-1.9,2.87a5,5,0,0,1-2.56,1.46,4.78,4.78,0,0,1-2.46-.11,5.09,5.09,0,0,1-1.65-.88A6.24,6.24,0,0,1,353.37,204.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.28,204.93a1.37,1.37,0,0,0-.11.52,4.12,4.12,0,0,0,.14,1.47,5.15,5.15,0,0,0,1.05,1.93,6.22,6.22,0,0,0,2.22,1.57,9.47,9.47,0,0,0,4.9.54,13.07,13.07,0,0,0,1.47-.29,1.62,1.62,0,0,0,.52-.17s-.77.14-2,.27a9.8,9.8,0,0,1-4.77-.59,6.16,6.16,0,0,1-2.14-1.49,5.14,5.14,0,0,1-1.05-1.82A5.74,5.74,0,0,1,348.28,204.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.49,302c-.17,12.86-8,24.71-18.24,32.52s-22.64,12.14-35,15.7-25,6.51-36.64,12c-16.1,7.62-31,18.07-40.12,33.39s-12.34,35.45-11.32,53.23L417,435.18l7.49-77.75Z",
    style: {
      fill: "#E53A47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.91,384.71a3.54,3.54,0,0,1-.35.56l-1.09,1.54c-.48.66-1.08,1.46-1.69,2.44s-1.39,2.05-2.09,3.34-1.56,2.62-2.31,4.17-1.56,3.18-2.34,4.94a84.33,84.33,0,0,0-4,11.88A93.73,93.73,0,0,0,283,425.93c-.18,1.92-.34,3.75-.39,5.46s-.1,3.31-.12,4.77,0,2.78.06,3.94.07,2.16.12,3,.06,1.4.08,1.88a2.73,2.73,0,0,1,0,.66,2.91,2.91,0,0,1-.1-.65c-.05-.48-.11-1.1-.18-1.87s-.17-1.81-.21-3-.15-2.48-.14-3.95,0-3.06.05-4.79.19-3.55.35-5.49a90,90,0,0,1,2.08-12.43,82.18,82.18,0,0,1,4-11.94c.8-1.76,1.56-3.44,2.4-4.95s1.62-2.91,2.37-4.17,1.53-2.33,2.17-3.3,1.26-1.76,1.77-2.41l1.16-1.47A3.13,3.13,0,0,1,298.91,384.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M421.49,302c-.17,12.86-8,24.71-18.24,32.52s-22.64,12.14-35,15.7-25,6.51-36.64,12c-16.1,7.62-31,18.07-40.12,33.39s-12.34,35.45-11.32,53.23L417,435.18l7.49-77.75Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-96"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.79,359.85a48.91,48.91,0,0,0-46.65-12.8,84.93,84.93,0,0,0,47.2,14.74",
    style: {
      fill: "#E53A47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,303.82c2-13.75-3.4-29.21-13.69-39.2-.34,13.62,5.41,28.95,13.69,39.2",
    style: {
      fill: "#E53A47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.19,329.79a73.37,73.37,0,0,0-33.71-32.22,46.33,46.33,0,0,0,33.84,32.36",
    style: {
      fill: "#E53A47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.9,334.8c-8.31.23-16.71-.06-24.74-2.19S59.44,326.4,54.1,320.05A82.53,82.53,0,0,1,99.77,334",
    style: {
      fill: "#E53A47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.68,318.29c4.22-15.79,11.17-26.72,23.59-35.57a32.84,32.84,0,0,1-23.59,35.57",
    style: {
      fill: "#E53A47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,345.53a23.37,23.37,0,0,0-14.2-21.65c.69,8.15,7.1,17.59,14.2,21.65",
    style: {
      fill: "#E53A47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131,332.22a34.83,34.83,0,0,1,22.82-29.72c-2.86,13.2-10.5,24.19-22.82,29.72",
    style: {
      fill: "#E53A47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125,355.85c2.93-4.19,7.71-6.79,12.65-8.09s10.11-1.41,15.22-1.51a35.58,35.58,0,0,1-27.48,11.44",
    style: {
      fill: "#E53A47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.08,389.52a39,39,0,0,1,47.6,22.55c-17.29-3.28-34.35-11-47.6-22.55",
    style: {
      fill: "#E53A47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.1,377.82c2.87,8.49,2.32,18.75-4.07,26.07a31.16,31.16,0,0,1,4.07-26.07",
    style: {
      fill: "#E53A47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.88,373.1A32,32,0,0,1,71.24,399a2,2,0,0,1-1.56.26c-.78-.32-.85-1.38-.75-2.22,1.25-10.88,9.31-21.4,19.95-24",
    style: {
      fill: "#E53A47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.55,372a26.19,26.19,0,0,1-38.26.19c12.16-1.33,26.2-2.22,38.26-.19",
    style: {
      fill: "#E53A47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.73,274.75a3.25,3.25,0,0,0,.12.35c.09.26.21.6.37,1,.34.93.83,2.25,1.46,3.94s1.41,3.81,2.29,6.25l1.41,3.9c.48,1.39,1,2.86,1.52,4.4,2.15,6.16,4.54,13.56,7.13,21.79s5.2,17.35,7.82,26.95,4.88,18.83,6.83,27.24,3.53,16,4.7,22.43c.31,1.6.59,3.13.87,4.57s.47,2.82.69,4.1c.44,2.55.82,4.75,1.07,6.56s.49,3.18.64,4.15c.08.46.13.82.18,1.08s.07.37.07.37a2.06,2.06,0,0,0,0-.37c0-.27-.08-.63-.14-1.09-.13-1-.31-2.38-.55-4.17s-.58-4-1-6.58c-.21-1.28-.43-2.65-.66-4.1l-.83-4.58c-1.14-6.43-2.74-14-4.61-22.47s-4.21-17.63-6.8-27.26-5.3-18.71-7.86-27-5-15.62-7.23-21.76c-.55-1.54-1.06-3-1.55-4.4s-1-2.67-1.45-3.89c-.9-2.43-1.68-4.53-2.36-6.22s-1.18-3-1.55-3.91c-.17-.43-.31-.76-.41-1A2.17,2.17,0,0,0,79.73,274.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.55,309.54l-.21.2-.58.61c-.51.54-1.24,1.35-2.16,2.42a85.15,85.15,0,0,0-7.16,9.55,64,64,0,0,0-7.49,16c-2,6.37-3.26,13.62-4.5,21.2-2.47,15.17-5.5,28.75-7.7,38.58l-2.64,11.63c-.3,1.35-.53,2.42-.7,3.17-.07.34-.12.61-.17.83a1.44,1.44,0,0,0,0,.28,1.1,1.1,0,0,0,.09-.27c0-.21.12-.48.21-.82l.79-3.15c.66-2.77,1.61-6.72,2.78-11.6,2.28-9.81,5.37-23.39,7.84-38.57,1.24-7.58,2.47-14.81,4.45-21.16a64.6,64.6,0,0,1,7.35-16,92.47,92.47,0,0,1,7-9.61c.89-1.09,1.61-1.91,2.09-2.47l.55-.65C146.5,309.63,146.56,309.55,146.55,309.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.92,371.48a1.59,1.59,0,0,0,.44.08l1.26.14.91.09,1.07.16c.78.11,1.66.23,2.62.44l1.51.3,1.61.41c1.13.25,2.29.67,3.53,1a52.64,52.64,0,0,1,7.71,3.39,43.83,43.83,0,0,1,6.9,4.8,32.51,32.51,0,0,1,2.65,2.55,28.86,28.86,0,0,1,2.1,2.41c.64.74,1.09,1.51,1.55,2.14a16.24,16.24,0,0,1,1.06,1.7l.65,1.08a1.71,1.71,0,0,0,.25.37s0-.15-.17-.41-.34-.68-.57-1.13a14.87,14.87,0,0,0-1-1.75,25.08,25.08,0,0,0-1.51-2.2,26.84,26.84,0,0,0-2.08-2.48,32.82,32.82,0,0,0-2.65-2.6,41.91,41.91,0,0,0-7-4.88,50.42,50.42,0,0,0-7.79-3.4c-1.26-.36-2.43-.76-3.57-1l-1.64-.39-1.53-.27c-1-.2-1.85-.29-2.63-.38l-1.09-.12-.92-.05-1.27,0A1.35,1.35,0,0,0,77.92,371.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.46,309.84a6.57,6.57,0,0,0,.87.84l2.51,2.17c2.12,1.82,5.08,4.31,8.37,7s6.28,5.18,8.46,6.93l2.6,2.06a5.37,5.37,0,0,0,1,.7,6.36,6.36,0,0,0-.88-.84l-2.5-2.17c-2.13-1.82-5.09-4.31-8.37-7s-6.28-5.18-8.46-6.93l-2.6-2.06A5.37,5.37,0,0,0,74.46,309.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.47,325.93c0,.12,6.35,2.12,14.26,4.45s14.36,4.14,14.4,4-6.35-2.12-14.27-4.46S71.5,325.8,71.47,325.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.05,319.52a5,5,0,0,0,.66-.92L97.39,316c1.43-2.16,3.46-5.11,5.86-8.25s4.71-5.87,6.41-7.82l2-2.31a5.28,5.28,0,0,0,.71-.88,5.17,5.17,0,0,0-.84.76c-.52.5-1.25,1.26-2.14,2.21-1.76,1.9-4.12,4.61-6.53,7.76s-4.4,6.14-5.76,8.35c-.68,1.11-1.22,2-1.57,2.65A5,5,0,0,0,95.05,319.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.23,328.45a22.71,22.71,0,0,0,1.5,2.47c1,1.5,2.25,3.58,3.59,5.94s2.47,4.53,3.27,6.12a21,21,0,0,0,1.36,2.55,15.83,15.83,0,0,0-1.06-2.69c-.73-1.63-1.82-3.84-3.16-6.21s-2.7-4.44-3.73-5.9A14.88,14.88,0,0,0,117.23,328.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.82,356.29c0,.06,1.25-.53,3.25-1.43s4.78-2.07,7.92-3.18,6.06-1.92,8.18-2.46,3.44-.83,3.43-.9a3.07,3.07,0,0,0-.95.1c-.61.09-1.48.25-2.56.48a70.84,70.84,0,0,0-8.25,2.35,69.93,69.93,0,0,0-7.91,3.31c-1,.49-1.77.91-2.3,1.21A3.89,3.89,0,0,0,124.82,356.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.85,389.57a1.49,1.49,0,0,0,.39.13l1.15.29,4.25,1a142.09,142.09,0,0,1,13.87,3.67,61.24,61.24,0,0,1,13,6.08c1.55,1,2.75,1.85,3.56,2.48a13.42,13.42,0,0,0,1.29.95,1.83,1.83,0,0,0-.28-.3c-.21-.18-.49-.46-.89-.79a38.77,38.77,0,0,0-3.5-2.62,56.84,56.84,0,0,0-13-6.24,114.4,114.4,0,0,0-14-3.55l-4.28-.83A11,11,0,0,0,118.85,389.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.24,397.77c.13,0,.89-4.46,1.7-10s1.37-10.05,1.24-10.07-.89,4.46-1.7,10S97.11,397.75,97.24,397.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.75,389.6a22.94,22.94,0,0,0,2-2.41c1.22-1.51,2.9-3.59,4.81-5.86s3.67-4.28,5-5.74a24.19,24.19,0,0,0,2-2.41s-.25.17-.64.55-1,.93-1.62,1.63c-1.35,1.41-3.16,3.4-5.07,5.67s-3.55,4.4-4.71,6c-.57.79-1,1.43-1.33,1.88A2.82,2.82,0,0,0,74.75,389.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.28 410.46 134.28 421.58 131.5 421.58 121.62 452.76 99.71 452.76 90.14 421.89 86.43 421.58 86.43 410.46 134.28 410.46",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.28,421.89c0,.13,9.68.23,21.61.23s21.61-.1,21.61-.23-9.68-.23-21.61-.23S88.28,421.76,88.28,421.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.53,350.39a7,7,0,0,0,1.4.38l3.85.93c3.24.8,7.69,2,12.52,3.64s9.11,3.35,12.17,4.67l3.63,1.58a8.26,8.26,0,0,0,1.35.55,9,9,0,0,0-1.27-.71c-.83-.43-2.05-1-3.57-1.72a125.24,125.24,0,0,0-12.17-4.81,127.08,127.08,0,0,0-12.59-3.52c-1.63-.36-3-.63-3.88-.78A9.81,9.81,0,0,0,72.53,350.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.56,439.2c0,.13,6.79.24,15.16.24s15.16-.11,15.16-.24-6.79-.23-15.16-.23S95.56,439.08,95.56,439.2Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.71,436.63c0,.12,7.19.23,16.06.23s16.07-.11,16.07-.23-7.2-.24-16.07-.24S94.71,436.5,94.71,436.63Z",
    style: {
      fill: "#fafafa"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthBg);
export default __webpack_public_path__ + "static/media/authBg.b73f1a318c72228d269dc67a2720b509.svg";
export { ForwardRef as ReactComponent };